<template>
  <div class="new-page-con">
    <div class="layout_header">
      <Header> </Header>
    </div>
    <div class="dataapi-page dataServices-page">
      <!-- 工具栏 -->
      <ToolBar
        :ToolBarData="ToolBarData"
        @fitlers="triggerIsFitlers"
        @select="triggerIsSelect"
        @reselect="triggerIsReselect"
        @download="triggerIsDownload"
      />
      <div
        class="apilistfix"
        v-if="
          ['APIHomepage_more', 'APIHomepage_more_detail'].includes(routeName)
        "
      >
        <div
          @click="apilistClick(item)"
          class="api-type"
          v-for="(item, index) in apiDataCategoryList"
          :key="index"
        >
          {{ item.categoryName }}
        </div>
      </div>

      <div
        :class="[
          'dataapi-content',
          showMargin ? 'margintopadd50' : '',
          asideWidth == '70px' ? 'asideWidth70' : '',
        ]"
      >
        <el-container>
          <el-aside :width="asideWidth" class="aside-fixed">
            <router-link :to="{ name: 'APIHomepage' }">
              <div
                :class="[
                  routeName == 'APIHomepage' ||
                  routeName == 'APIHomepage_more' ||
                  routeName == 'APIHomepage_more_detail'
                    ? 'menu-item-first-active menu-item-first'
                    : 'menu-item-first',
                ]"
              >
                <img
                  src="../../../assets/images/dataServices/dataapi-img/APIHomepage.svg"
                  alt=""
                />
                <span v-if="asideWidth == '240px'">API Homepage</span>
              </div>
            </router-link>
            <div>
              <div class="menu-item-two" v-if="asideWidth == '240px'">
                <span>API Management Center</span>
              </div>
              <div class="menu-item-two-child">
                <router-link :to="{ name: 'AccountManagement' }">
                  <div
                    :class="[
                      'menu-item-two-child-item',
                      routeName == 'AccountManagement'
                        ? 'menu-item-two-active'
                        : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName == 'AccountManagement'
                          ? require('../../../assets/images/dataServices/dataapi-img/AccountManagement-active.svg')
                          : require('../../../assets/images/dataServices/dataapi-img/AccountManagement.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">Account Management</span>
                  </div>
                </router-link>
                <router-link :to="{ name: 'Test' }">
                  <div
                    :class="[
                      'menu-item-two-child-item',
                      routeName == 'Test' ? 'menu-item-two-active' : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName == 'Test'
                          ? require('../../../assets/images/dataServices/dataapi-img/Test-active.svg')
                          : require('../../../assets/images/dataServices/dataapi-img/Test.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">Test</span>
                  </div>
                </router-link>
                <router-link :to="{ name: 'TestRecords' }">
                  <div
                    :class="[
                      'menu-item-two-child-item',
                      routeName == 'TestRecords' ? 'menu-item-two-active' : '',
                    ]"
                  >
                    <img
                      :src="[
                        routeName == 'TestRecords'
                          ? require('../../../assets/images/dataServices/dataapi-img/TestRecords-active.svg')
                          : require('../../../assets/images/dataServices/dataapi-img/TestRecords.svg'),
                      ]"
                      alt=""
                    />
                    <span v-if="asideWidth == '240px'">Test Records</span>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="aside-status-icon">
              <img
                src="../../../assets/images/dataServices/dataapi-img/foldup-aside.svg"
                alt=""
                @click="foldupAsideClick()"
                v-if="asideWidth == '240px'"
              />
              <img
                src="../../../assets/images/dataServices/dataapi-img/expand-aside.svg"
                alt=""
                @click="expandAsideClick()"
                v-if="asideWidth == '70px'"
              />
            </div>
          </el-aside>
          <el-main class="dataapi-content-main">
            <router-view
              :key="$route.fullPath"
              :TesRecordsPageData="TesRecordsPageData"
              @fitlers="triggerIsFitlersTrue"
              @update-selection="handleSelectionChange"
            />
          </el-main>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../layout/header.vue";
import ToolBar from "../components/toolBar.vue";
import {
  getApiDataCategory,
  downloadPatchCategory,
  downloadPatchApi
} from "@/api/dataServicesApi";
import { downloadFromBase64, downloadFile } from "@/utils/date";
export default {
  components: {
    Header,
    ToolBar,
  },
  name: "dataApi",
  data() {
    return {
      asideWidth: "240px",
      TesRecordsPageData: {
        isOpen: false,
        isShowCheckBtn_APIH: false, //显示隐藏复选框
        isShowCheckBtn_APIH_m: false,
        isShowCheckBtn_AManagment: false,
        // isShowCheckBtn_TRecords:false,
        isReselectCheckBtn_APIH: false, //重置选中的复选框
        isReselectCheckBtn_APIH_m: false,
        isReselectCheckBtn_AManagment: false,
      },
      ToolBarData: {},

      routeName: "APIHomepage",
      apimodulesList: [
        "Admin Data",
        "Contact_Info",
        "Owenship data",
        "Related Companies",
        "Financial performance",
        "Analytics",
        "Import&Export",
        "Negative",
        "Operation data",
        "Publications",
      ],
      apiDataCategoryList: [],
      selectedApiData: [], //子组件中被选中的api数据列表
      downloadType:0,
    };
  },
  mounted() {
    this.$store.dispatch("app/setThemColor", "#B98B73");
    this.$store.dispatch("app/setSearchType", "dataServices");
    // 获取当前路径 给菜单高亮
    this.routeName = this.$route.name;
  },
  computed: {
    showMargin() {
      return ["APIHomepage_more", "APIHomepage_more_detail"].includes(
        this.routeName
      );
    },
  },
  watch: {
    // 监听整个 $route 对象的变化（路径、query、params 等）
    $route: {
      handler(to, from) {
        this.routeName = to.name;
        console.log("routeName", this.routeName);
        if (this.routeName === "APIHomepage") {
          this.ToolBarData = {
            isSelectDisabled: false,
            isDownloadDisabled: true,
            isReselectDisabled: false,
            isCreateComponentDisabled: false,
          };
        } else if (this.routeName === "APIHomepage_more") {
          this.ToolBarData = {
            isSelectDisabled: false,
            isDownloadDisabled: true,
            // isReselectDisabled: false,
            isCreateCombDisabled: false,
          };
        } else if (this.routeName === "APIHomepage_more_detail") {
          this.ToolBarData = {
            // isDownloadDisabled: false,
            isCreateCombDisabled: false,
          };
        } else if (this.routeName === "AccountManagement") {
          this.ToolBarData = {
            isSelectDisabled: false,
            // isDownloadDisabled: false,
            isCreateCombDisabled: false,
          };
        } else if (this.routeName === "Test") {
          this.ToolBarData = {};
        } else if (this.routeName === "TestRecords") {
          this.ToolBarData = {
            isExportDisabled: false,
            isFitlersDisabled: false,
            isCreateComponentShow: false,
            isExportShow: true,
            isFitlersShow: true,
          };
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getApiDataCategoryList();
  },
  methods: {
    foldupAsideClick() {
      this.asideWidth = "70px";
    },
    expandAsideClick() {
      this.asideWidth = "240px";
    },
    // Fitlers工具不可点击
    triggerIsFitlers() {
      this.TesRecordsPageData.isOpen = true;
      this.ToolBarData.isFitlersDisabled = true;
    },
    // Fitlers工具可点击
    triggerIsFitlersTrue() {
      this.TesRecordsPageData.isOpen = false;
      this.ToolBarData.isFitlersDisabled = false;
    },
    // 点击select工具页面的复选框才会显示
    triggerIsSelect() {
      if (this.routeName === "APIHomepage") {
        this.TesRecordsPageData.isShowCheckBtn_APIH =
          !this.TesRecordsPageData.isShowCheckBtn_APIH;
      } else if (this.routeName === "APIHomepage_more") {
        this.TesRecordsPageData.isShowCheckBtn_APIH_m =
          !this.TesRecordsPageData.isShowCheckBtn_APIH_m;
      } else if (this.routeName === "AccountManagement") {
        this.TesRecordsPageData.isShowCheckBtn_AManagment =
          !this.TesRecordsPageData.isShowCheckBtn_AManagment;
      }
    },
    // 取消所有选中的复选框
    triggerIsReselect() {
      if (this.routeName === "APIHomepage") {
        this.TesRecordsPageData.isReselectCheckBtn_APIH = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_APIH = false;
          }, 100);
        });
      } else if (this.routeName === "APIHomepage_more") {
        this.TesRecordsPageData.isReselectCheckBtn_APIH_m = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_APIH_m = false;
          }, 100);
        });
      } else if (this.routeName === "AccountManagement") {
        this.TesRecordsPageData.isReselectCheckBtn_AManagment = true;
        this.$nextTick(() => {
          // 点击后重置下 方便多次点击
          setTimeout(() => {
            this.TesRecordsPageData.isReselectCheckBtn_AManagment = false;
          }, 100);
        });
      }
    },
    // 接收子组件传来的数据
    handleSelectionChange(data,type) {
      this.selectedApiData = data;
      if(!this.selectedApiData.length){
        // 没有选api列表
        this.ToolBarData.isDownloadDisabled = true
      }else{
        this.ToolBarData.isDownloadDisabled = false
      }
      this.downloadType=type
      console.log("父组件收到选中数据:", data,type);
    },
    // 点击下载api接口文档zip
    async triggerIsDownload() {
      if (this.downloadType==1) {
        let params = {
          categoryIds: this.selectedApiData,
        };
        downloadPatchCategory(params).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "api.zip";
            link.click();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if(this.downloadType==2) {
        let params = {
          apiIds: this.selectedApiData,
        };
        downloadPatchApi(params).then((res) => {
          if (res) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.download = "api.zip";
            link.click();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 获取api列表
    getApiDataCategoryList() {
      //根据分类名称获取标签精准查询的参数
      let params = {
        // categoryName:"测试",
        // labelIds:[1,2]
      };
      getApiDataCategory(params).then((res) => {
        if (res.code == 200) {
          this.apiDataCategoryList = JSON.parse(JSON.stringify(res.data));
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 当页面在APIHomepage_more和APIHomepage_more_detail中 点击切换不同类型的more列表
    apilistClick(row) {
      this.$router.push({
        name: "APIHomepage_more",
        query: { id: row.id, categoryName: row.categoryName },
      });
    },
  },
};
</script>
<style scoped>
.dataapi-page {
  overflow: auto;
}
.dataapi-content {
  margin: 76px 20px 20px 20px;
}
.dataapi-content.margintopadd50 {
  margin: 80px 20px 20px 20px;
}
.dataapi-content.margintopadd50 .el-container .el-aside {
  top: 218px;
  height: calc(100vh - 250px);
}
.dataapi-content .el-container .el-aside {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 14px;
  position: fixed;
  top: 165px;
  left: 20px;
  height: calc(100vh - 194px);
  min-height: 350px;
  /* width: 240px !important; 覆盖 el-aside 默认样式 */
  z-index: 100;
  background-color: #fff;
  border-right: 1px solid #ebeef5;
  overflow-y: auto; /* 如果菜单项太多，允许菜单自身滚动 */
}

.menu-item-first {
  width: 100%;
  height: 48px;
  line-height: 48px;
  padding: 0 14px;
  font-size: 18px;
  color: #1a2332;
  border: 1px solid #b98b73;
  border-radius: 8px;
  margin-bottom: 28px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0 10px;
}
.asideWidth70 .menu-item-first {
  justify-content: center;
}
.menu-item-first img {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  margin-right: 10px;
}
.menu-item-first-active {
  background: linear-gradient(180deg, #ecab89 0%, #ffffff 62%);
}
.menu-item-two {
  font-size: 16px;
  color: #999999;
  margin-bottom: 14px;
}
.menu-item-two-child {
  font-size: 16px;
}
.menu-item-two-child .menu-item-two-child-item {
  margin-bottom: 8px;
  color: #666666;
  padding: 9px 12px;
  background: transparent;
  border-radius: 8px;
}
.menu-item-two-child .menu-item-two-child-item img {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin-right: 13px;
}
.menu-item-two-child .menu-item-two-child-item.menu-item-two-active {
  color: #1a2332;
  background: #f2f3f7;
}
.dataapi-content-main {
  margin: 0 20px 0px 260px;
  padding: 0;
  /* min-height: 100vh;  */
}
/* 展开收起 */
.aside-status-icon {
  border-top: 1px solid #cccccc;
  position: absolute;
  bottom: 10px;
  width: 200px;
  padding: 20px 0 10px 0;
  cursor: pointer;
}
.asideWidth70 .dataapi-content-main {
  margin-left: 90px;
}
.asideWidth70 .aside-status-icon {
  width: 30px;
}
.asideWidth70 .menu-item-first {
  padding: 0 6px;
  margin-bottom: 14px;
}
.asideWidth70 .menu-item-first img {
  margin-right: 0px;
}
.dataapi-content.asideWidth70 .el-container .el-aside {
  padding: 20px 10px;
}
/* 整个滚动条 */
.dataapi-content-main::-webkit-scrollbar {
  width: 2px !important; /* 垂直滚动条宽度 */
  height: 2px !important; /* 水平滚动条高度 */
}
.apilistfix {
  height: 50px;
  background: #b98b73;
  display: flex;
  justify-content: center;
  gap: 1rem;
  position: sticky;
  top: 56px;
  z-index: 101;
  align-items: center;
}
.apilistfix .api-type {
  padding: 5px 10px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  /* 字体 内容改成16px 包括按钮里字体*/
  /* 圆角 改成10px */
  /* padding *0.75 */
  /* margin *0.75 */
   /* 表格 表头高度 44px 内容高度50px */
   .dataapi-content {
    margin-top: 60px;
  }
   .dataapi-content .el-container .el-aside {
    top: 118px;
    height: calc(100vh - 138px);
  }
  .dataapi-content.margintopadd50 {
    margin-top: 60px;
  }
  .dataapi-content.margintopadd50 .el-container .el-aside {
    height: calc(100vh - 188px);
    top: 168px;
  }
  .apilistfix {
    top: 40px;
  }
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  /* 字体 内容改成14px 包括按钮里字体*/
  /* 圆角 改成8px */
  /* padding *0.67 */
  /* margin *0.67 */
  /* 表格 表头高度 40px 内容高度44px*/
  .dataapi-content {
    margin-top: 60px;
  }
  .dataapi-content .el-container .el-aside {
    height: calc(100vh - 138px);
    top: 118px;
    left: 20px;
  }
  .dataapi-content.margintopadd50 {
    margin-top: 60px;
  }
  .dataapi-content.margintopadd50 .el-container .el-aside {
    height: calc(100vh - 188px);
    top: 168px;
    left: 20px;
  }
  .apilistfix {
    top: 40px;
  }
}
</style>
